// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.todg4eZ7rzC2iQWSAs_R {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
  height: 100%;
}

.eh3NLlyxr3m86Tvsv3Md {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 5px;
  margin-bottom: 90px;
}

.GS2zjQ0ZiULmu_u8n7NS {
  color: #1c77ff;
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border: none;
  transition: background 0.3s ease 0s;
  justify-content: flex-end;
}

.GS2zjQ0ZiULmu_u8n7NS:first-child {
  justify-content: flex-start;
}

.GS2zjQ0ZiULmu_u8n7NS:hover {
  color: #055ada;
  background: transparent;
}

.JwONX9M6THmyVNa0KG0Y {
  font-size: 17px;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  margin: 0 auto;
}

.Xq0KAcXFjnw1x_IBvXEX {
  color: rgb(var(--placeholder-primary));
  padding-bottom: 43px;
}

.NaPE_rF6Jr6O6gcade7D {
  background: radial-gradient(53.5% 50% at 50% 50%, rgba(0, 234, 23, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;
}

.AezeI4CaUZSW96wRQk6A {
  background: radial-gradient(53.5% 50% at 50% 50%, rgba(234, 42, 0, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;
}

.Xq0KAcXFjnw1x_IBvXEX img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 170px;
  margin: 0 auto 8px auto;
  position: relative;
  z-index: 5;
}

.SAkypNtXXUCFdLVmcaEA {
  font-weight: 760;
  font-size: 26px;
  text-align: center;
  line-height: 93%;
  letter-spacing: 0.43px;
  margin-bottom: 30px;
  color: rgb(var(--placeholder-primary));
}

.LQEk1oT3v1UNVcIjiTAQ {
  margin-top: 8px;
  font-size: 12px;
  line-height: 112.5%;
  letter-spacing: 0.7px;
  text-align: center;
  font-weight: 540;
  color: rgb(var(--accent-error));
}

.Czt0WF2PuAQTHQBrDYqv {
  font-size: 16px;
  line-height: 112.5%;
  letter-spacing: 0.7px;
  text-align: center;
  font-weight: 540;
  color: rgb(var(--placeholder-primary));
}

.wORodcj5h8AllB44WAze {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.H4gXBD2LtsFcClIKP9Ls {
  margin-top: auto;
  width: 100%;
  font-size: 17px;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/send-status/send-success.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,yHAAyH;AAC3H;;AAEA;EACE,yHAAyH;AAC3H;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n  height: 100%;\n}\n\n.modalTop {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 90px;\n}\n\n.modalTopButton {\n  color: #1c77ff;\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  transition: background 0.3s ease 0s;\n  justify-content: flex-end;\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  color: #055ada;\n  background: transparent;\n}\n\n.modalTitle {\n  font-size: 17px;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  margin: 0 auto;\n}\n\n.modalContent {\n  color: rgb(var(--placeholder-primary));\n  padding-bottom: 43px;\n}\n\n.success {\n  background: radial-gradient(53.5% 50% at 50% 50%, rgba(0, 234, 23, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;\n}\n\n.error {\n  background: radial-gradient(53.5% 50% at 50% 50%, rgba(234, 42, 0, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;\n}\n\n.modalContent img {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 170px;\n  height: 170px;\n  margin: 0 auto 8px auto;\n  position: relative;\n  z-index: 5;\n}\n\n.modalContentTitle {\n  font-weight: 760;\n  font-size: 26px;\n  text-align: center;\n  line-height: 93%;\n  letter-spacing: 0.43px;\n  margin-bottom: 30px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.modalContentTextErr {\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 112.5%;\n  letter-spacing: 0.7px;\n  text-align: center;\n  font-weight: 540;\n  color: rgb(var(--accent-error));\n}\n\n.modalContentText {\n  font-size: 16px;\n  line-height: 112.5%;\n  letter-spacing: 0.7px;\n  text-align: center;\n  font-weight: 540;\n  color: rgb(var(--placeholder-primary));\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.modalContentBtn {\n  margin-top: auto;\n  width: 100%;\n  font-size: 17px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `todg4eZ7rzC2iQWSAs_R`,
	"modalTop": `eh3NLlyxr3m86Tvsv3Md`,
	"modalTopButton": `GS2zjQ0ZiULmu_u8n7NS`,
	"modalTitle": `JwONX9M6THmyVNa0KG0Y`,
	"modalContent": `Xq0KAcXFjnw1x_IBvXEX`,
	"success": `NaPE_rF6Jr6O6gcade7D`,
	"error": `AezeI4CaUZSW96wRQk6A`,
	"modalContentTitle": `SAkypNtXXUCFdLVmcaEA`,
	"modalContentTextErr": `LQEk1oT3v1UNVcIjiTAQ`,
	"modalContentText": `Czt0WF2PuAQTHQBrDYqv`,
	"modal": `wORodcj5h8AllB44WAze`,
	"modalContentBtn": `H4gXBD2LtsFcClIKP9Ls`
};
export default ___CSS_LOADER_EXPORT___;
